import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private activeRequests = 0;
  private spinnerSubject = new BehaviorSubject<boolean>(false);
  spinnerState$ = this.spinnerSubject.asObservable();

  constructor() {}

  show() {
    this.activeRequests++;
    if (!this.spinnerSubject.value) {
      this.spinnerSubject.next(true);
    }
  }

  hide() {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    if (this.activeRequests === 0 && this.spinnerSubject.value) {
      this.spinnerSubject.next(false);
    }
  }
}
